import { render, staticRenderFns } from "./RideitPassengerTokenList.vue?vue&type=template&id=58fa20ca&scoped=true"
import script from "./RideitPassengerTokenList.vue?vue&type=script&lang=ts"
export * from "./RideitPassengerTokenList.vue?vue&type=script&lang=ts"
import style0 from "./RideitPassengerTokenList.vue?vue&type=style&index=0&id=58fa20ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fa20ca",
  null
  
)

export default component.exports